import {Component, effect, input, output} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {TaxSummary} from '../../../../../../../../../api';
import {TaxFormModel} from '../../models/tax-form-model';
import {TextInput} from '../../../../../../../../components/text-input/text-input';
import {NumericInput} from '../../../../../../../../components/numeric-input/numeric-input';
import {CheckBox} from '../../../../../../../../components/check-box/check-box';
import {AccountingAccountDropdown} from '../../../accounting-accounts/components/accounting-account-dropdown/accounting-account-dropdown';

export interface TaxFormValue {
  id: number | null;
  nameFr: string | null;
  nameEn: string | null;
  nameNl: string | null;
  rate: number | null;
  peppolCode: string | null;
  isDefault: boolean | null;
  deductibleVatPercentage: number | null;
  accountingAccountId: number | null;
  accountingCode: string | null;
  accountingAccount2Id: number | null;
  accountingCode2: string | null;
}

@Component({
  selector: 'elcia-accounting-tax-form',
  imports: [ReactiveFormsModule, TranslatePipe, TextInput, NumericInput, CheckBox, AccountingAccountDropdown],
  templateUrl: './accounting-tax-form.html',
})
export class AccountingTaxForm {
  initialValue = input<TaxSummary | null>(null);
  onSubmit = output<TaxFormValue>();

  protected readonly form = new FormGroup<TaxFormModel>({
    id: new FormControl<number | null>(null),
    nameFr: new FormControl<string | null>(null, Validators.required),
    nameEn: new FormControl<string | null>(null, Validators.required),
    nameNl: new FormControl<string | null>(null, Validators.required),
    rate: new FormControl<number | null>(null, Validators.required),
    peppolCode: new FormControl<string | null>(null, Validators.required),
    isDefault: new FormControl<boolean | null>(false),
    deductibleVatPercentage: new FormControl<number | null>(null, Validators.required),
    accountingAccountId: new FormControl<number | null>(null),
    accountingCode: new FormControl<string | null>(null),
    accountingAccount2Id: new FormControl<number | null>(null),
    accountingCode2: new FormControl<string | null>(null),
  });

  private readonly onInitialValueChange = effect(() => {
    const tax = this.initialValue();
    if (!tax) {
      this.form.reset({isDefault: false});
      return;
    }
    this.form.reset({
      id: tax.id,
      nameFr: tax.nameFr,
      nameEn: tax.nameEn,
      nameNl: tax.nameNl,
      rate: tax.rate,
      peppolCode: tax.peppolCode,
      isDefault: tax.isDefault,
      deductibleVatPercentage: tax.deductibleVatPercentage,
      accountingAccountId: tax.accountingAccountId ?? null,
      accountingCode: tax.accountingCode ?? null,
      accountingAccount2Id: tax.accountingAccount2Id ?? null,
      accountingCode2: tax.accountingCode2 ?? null,
    });
  });

  public submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.onSubmit.emit(this.form.getRawValue());
  }
}
